































    import Vue from 'vue'
    import Component from 'vue-class-component';

    @Component
	export default class Home extends Vue {
        name: string = 'Home';
        isLoading: boolean = true;

        mounted() {
            this.isLoading = false;
        }
	}
